import '../src/assets/styles/base/flex.scss';
import '../src/assets/styles/base/spacing.scss';
import './App.scss';

import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';

//  components
import SideBar from './components/sidebar/SideBar';
// import Login from "./pages/login/Login";
// import Signup from "./pages/signup/Signup";
import HeaderNav from './components/navbar/navbar';
import LoginHeader from './components/loginHeader/LoginHeader';

// import Topology from './pages/topology/topology.jsx';
// import ExamplePage from './components/DataTable/ExamplePage.js';
// import SystemSettings from './pages/systemSettings/systemSettings.jsx';
// import ClientDashboard from './pages/clientDashboard/clientDashboard.jsx';
// import Maintenance from './pages/maintenance/Maintenance.jsx';
// import AccessPointDashboard from './components/accessPonitDashboard/accessPointDashboard.jsx';
// import IOPass from './pages/IO-Pass/ioPass.jsx';
// import AccountDetails from './pages/accountDetails/AccountDetails.jsx';
// import PasswordAnd2FA from './pages/passwordAnd2FA/PasswordAnd2FA.jsx';
// import SwitchDetail from './pages/switch/switch-detail/SwitchDetail.jsx';
// import GlobalProfiles from './pages/systemSettings/globalprofile.jsx';
import WebSocketComponent from './components/webSockets/webSocket.js';
// import { useSelector, useDispatch } from 'react-redux';
import Toast from './components/toast/Toast.jsx';
// import { useState } from 'react';
// import { useEffect, useRef } from 'react';
import useTheme from './hooks/useTheme.js';
// import { LOGIN_SUCCESS } from './constants/commonConstants';
import RoutePage from './pages/dashboard/RoutePage.jsx'
import FirstTimeLoginGuard from './pages/dashboard/FirstTimeLoginGaurd.jsx'
import { ActivityBanner } from './components/activityBanner/index.jsx';
// import { Box } from '@mui/material';
import { addActivityBannerMessage, updateActivityBannerMessage} from './actions/activityBannerActions.js';
import { TopologySidebarWrapper } from './pages/topology/topology-fixed/TopologySidebarWrapper.jsx';
import { setBulkOperationStatus } from './actions/bulkStatusAction.js';

// Lazy load ALL heavy pages
const HomePage = lazy(() => import(/* webpackChunkName: "Home" */ './pages/dashboard/Dashboard.jsx'));
const Login = lazy(() => import(/* webpackChunkName: "Home" */ './pages/login/Login.jsx'));
const Signup = lazy(() => import(/* webpackChunkName: "Home" */ './pages/signup/Signup.jsx'));
const OtpVerification =lazy(() => import(/* webpackChunkName: "Home" */ './pages/otpVerification/OtpVerification.jsx'));
const ResetPassword = lazy(() => import(/* webpackChunkName: "Home" */ './pages/resetPassword/ResetPassword.jsx'));
const SignInOtpVerify = lazy(() => import(/* webpackChunkName: "Home" */ './pages/loginOtpVerify/LoginOtpVerify.jsx'));
const UploadLicense = lazy(() => import(/* webpackChunkName: "Home" */ './pages/uploadLicense/UploadLicense.jsx'));

const Topology = lazy(() => import(/* webpackChunkName: "Dashboard" */'./pages/topology/topology.jsx'));
const ExamplePage = lazy(() => import(/* webpackChunkName: "Dashboard" */'./components/DataTable/ExamplePage.js'));
const SystemSettings = lazy(() => import(/* webpackChunkName: "Dashboard" */'./pages/systemSettings/systemSettings.jsx'));
const ClientDashboard = lazy(() => import(/* webpackChunkName: "Dashboard" */'./pages/clientDashboard/clientDashboard.jsx'));
const Maintenance = lazy(() => import(/* webpackChunkName: "Dashboard" */'./pages/maintenance/Maintenance.jsx'));

// These are now lazy loaded as requested
const AccessPointDashboard = lazy(() => import('./components/accessPonitDashboard/accessPointDashboard.jsx'));
const IOPass = lazy(() => import('./pages/IO-Pass/ioPass.jsx'));
const AccountDetails = lazy(() => import('./pages/accountDetails/AccountDetails.jsx'));
const PasswordAnd2FA = lazy(() => import('./pages/passwordAnd2FA/PasswordAnd2FA.jsx'));
const SwitchDetail = lazy(() => import('./pages/switch/switch-detail/SwitchDetail.jsx'));
const GlobalProfiles = lazy(() => import('./pages/systemSettings/globalprofile.jsx'));

/**
 * Main application component.
 *
 * This component renders the main layout of the application, including the header, sidebar, and routes.
 *
 * @return {JSX.Element} The JSX element representing the application layout.
 */
function App() {
	// const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	// const [isOverlapped, setIsOverlap] = useState(false);
	const isOverlapped = false;
	// const [isOpen, setIsOpen] = useState(false);
	// const userLogin = useSelector((state) => state.userLogin);
	// const { userInfo } = userLogin;
	const dispatch = useDispatch();
	const { color } = useTheme('LIGHT');
	const pathname = window.location.pathname;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

	console.log('pathname = ', pathname);
	// /,/signup, /reset/password
	const webSocketMessage = useSelector((state) => state.webSocket.message);
  const [toastVisible, setToastVisible] = React.useState(false);
	const bulkTimeoutRef = useRef(null);

	// useEffect(() => {
	// 	if (webSocketMessage) {
	// 		setToastVisible(true);
	// 		setTimeout(() => {
	// 			setToastVisible(false);
	// 		}, 4000); // 4000ms = 4 seconds
	// 	}
	// }, [webSocketMessage]);

	// Clean up timeout on unmount
	useEffect(() => {
		return () => {
		if (bulkTimeoutRef.current) {
			clearTimeout(bulkTimeoutRef.current);
		}
		};
	}, []);

	  // Extract progress percentage from WebSocket message
	  const extractProgress = (message) => {
		const progressMatch = message.match(/(\d+)%/);
		return progressMatch ? parseInt(progressMatch[1], 10) : null;
	  };

	useEffect(() => {
		// List of paths for which no WebSocket message should appear in the UI
		const excludedPaths = ['/', '/signup', '/reset/password', '/license/upload', '/signin/otpverify'];

		// If the current pathname is in the excluded list, exit early.
		if (excludedPaths.includes(pathname)) {
		  return;
		}
		if (webSocketMessage) {
			const lowerCaseMessage = webSocketMessage.toLowerCase();
			const isBulkMessage = lowerCaseMessage.includes('bulk');
			// Handle bulk status
			if (isBulkMessage) {
				// Clear any existing timeout
				if (bulkTimeoutRef.current) {
				clearTimeout(bulkTimeoutRef.current);
				}

				// Set status to true immediately
				dispatch(setBulkOperationStatus(true));

				// Set timeout to reset status after 5 seconds of inactivity
				bulkTimeoutRef.current = setTimeout(() => {
				dispatch(setBulkOperationStatus(false));
				}, 5000); // 5 seconds delay
			}
			// if (lowerCaseMessage.includes('bulk') || lowerCaseMessage.includes('firmware')) {
				const progress = extractProgress(webSocketMessage);
				const messageIdUpload = 'Bulk_Upload';
				const messageIdStandard = 'Notify';
				const title = lowerCaseMessage.includes('bulk')
					? 'Bulk Action in Progress'
					: lowerCaseMessage.includes('restore')
						? 'Restore in Progress'
						: lowerCaseMessage.includes('backup')
							? 'Backup in Progress'
							: '';
			
				if (progress !== null) {
					dispatch(
					updateActivityBannerMessage({
						messageId: messageIdUpload,
						title: title,
						message: `<p>${webSocketMessage}</p>`,
						variant: 'progress',
						progress:progress,
					})
					);
				} else {
					dispatch(
					addActivityBannerMessage({
						messageId: messageIdStandard,
						title: 'Notification',
						message: `<p>${webSocketMessage}</p>`,
					})
					);
				}
			// }
			}
	  }, [webSocketMessage, dispatch, pathname]);

	const announcementBannerClose = useSelector(
		(state) => state.announcementBannerCloseTrigger.announcementBannerClose
	);
	const maintenanceInstances = useSelector(
		(state) => state.maintenanceInstanceList.maintenanceInstances
	);
	const msg = maintenanceInstances?.data?.notification_msg;
    const loginHeaderPaths = ['/', '/signin', '/signup', '/reset/password', '/license/upload', '/signin/otpverify', '/signup/otp/verify'];

	return (
		<>
			<div
				style={{
					marginTop:
						(msg && !announcementBannerClose) > 0 ? '32px' : '0px',
					backgroundColor: color.background.primary,
				}}
			>
				<BrowserRouter>
					<RoutePage />
                    <FirstTimeLoginGuard />

					<div className="DashboardWrapper" style={{height: (msg && !announcementBannerClose) ? 'calc(100vh - 32px)' : '100vh',}}>
						{(pathname && loginHeaderPaths?.includes(pathname)) ? (
							<LoginHeader />
						) : (
							<>
								<HeaderNav />
								<SideBar
									setIsSidebarOpen={true}
									setIsOverlap={false}
								/>
							</>
						)}
						<div
							className={`app-components mt-50 ${
								isOverlapped ? 'overlapped' : 'open'
							}`}
						>
      <Suspense fallback={<div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',        // full-screen feel
        backgroundColor: 'transparent',
      }}
    >
      {/* Purple Circular Spinner */}
      <div
        style={{
          width: '50px',
          height: '50px',
          border: '5px solid #e2d9ff',           // light purple
          borderTop: '5px solid #7c4dff',        // main purple (you can use #6a0dad, #9333ea, etc.)
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      
      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>}>
                <Routes>
                  <Route index element={<Login />} />
                  <Route path="signin" element={<Login />} />
                  <Route path="signin/otpverify" element={<SignInOtpVerify />} />
                  <Route path="signup" element={<Signup />} />
                  <Route path="signup/otp/verify" element={<OtpVerification />} />
                  <Route path="license/upload" element={<UploadLicense />} />
                  <Route path="reset/password" element={<ResetPassword />} />

                  <Route path="Dashboard" element={<HomePage />} />
                  <Route path="Maintenance" element={<Maintenance />} />
                  <Route path="topology" element={<Topology />} />
                  <Route path="dataTable" element={<ExamplePage />} />
                  <Route path="system" element={<SystemSettings />} />
                  <Route path="template" element={<GlobalProfiles />} />
                  <Route path="iopass" element={<IOPass />} />

                  <Route path="client" element={
                    <TopologySidebarWrapper><ClientDashboard /></TopologySidebarWrapper>
                  } />
                  <Route path="accessPointDashboard" element={
                    <TopologySidebarWrapper><AccessPointDashboard /></TopologySidebarWrapper>
                  } />
                  <Route path="profile" element={
                    <TopologySidebarWrapper><AccountDetails /></TopologySidebarWrapper>
                  } />
                  <Route path="manage-password" element={
                    <TopologySidebarWrapper><PasswordAnd2FA /></TopologySidebarWrapper>
                  } />
                  <Route path="switch-detail/:switchId" element={
                    <TopologySidebarWrapper><SwitchDetail /></TopologySidebarWrapper>
                  } />
                </Routes>
              </Suspense>
						</div>
					</div>
					<div>
						{toastVisible && (
							<Toast
								message={webSocketMessage}
								isVisible={toastVisible}
								onCancel={() => setToastVisible(false)}
								messageType="info"
							/>
						)}
					</div>

					{userInfo && <WebSocketComponent />}

				</BrowserRouter>

			</div>

			<Box width={'100%'} display={'flex'} flexDirection={'column'} justifyContent={'end'} >
				<ActivityBanner/>
			</Box>
		</>
	);
}

export default App;
